import types from './types';

const defaultState = {
    showPersonalData: true
};

export default (
    state = defaultState,
    {
        type,
        params,
        request,
        response,
        data,
        ...action
    }
) => {
    switch (type) {
        case types.SET_DATA_PRIVACY:
            return { ...state, showPersonalData: !state.showPersonalData };

        default:
            return state;
    }
};
